<div class="col-12">
  <h6 class="fw-bold text-danger">
    Atenção: este vínculo está sendo utilizado como vínculo representado nos registros listados abaixo.
  </h6>
  <nz-table #basicTable [nzBordered]="true" [nzData]="itens" [nzSize]="'small'" [nzShowPagination]="false">
    <thead>
      <tr>
        <th nzWidth="40%">Nome da Entidade</th>
        <th nzWidth="40%">Nome da Pessoa</th>
        <th nzWidth="20%">Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of itens">
        <td>{{ item.nomePessoa }}</td>
        <td>{{ item.nomeEntidade }}</td>
        <td>
          <button
            nz-button
            nzType="link"
            (click)="abrirEmNovaGuia(item.id)">
            <i nz-icon nzType="edit" nzTheme="outline"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
<div class="col-12 mt-3">
  <p class="text-secondary fst-italic">
    Caso deseje prosseguir, o sistema irá desvincular automaticamente a entidade representada junto com o cargo representado
    de todos os registros que estão associando este vínculo como entidade representada.
  </p>
</div>
<div class="row mt-4">
  <div class="col-12 d-flex justify-content-end">
    <button nz-button nzType="default" class="ms-2" (click)="handleCancel()">Cancelar</button>
    <button nz-button nzType="primary" class="ms-2" (click)="handleProsseguir()">Prosseguir</button>
  </div>
</div>

